import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

let anonId = localStorage.getItem("ar_anon_id");
if (!anonId) {
  anonId = "anon_" + Math.random().toString(36).slice(2, 14);
  localStorage.setItem("ar_anon_id", anonId);
}

export const track = (event_name, properties = {}, page = window.location.pathname) => {
  api.post("/analytics/event", { event_name, properties, page, anonymous_id: anonId }).catch(() => {});
};
